import { useState } from 'react';
import { Input } from '../../atoms/legacy/Input';
import { Button } from '../../atoms/legacy/Button';

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function SearchInstance() {
  const [searchValue, setSearchValue] = useState('');

  return (
    <form action="/clients/listingSearch" className="flex flex-col gap-2">
      <Input
        label="Rechercher une instance"
        name="term"
        value={searchValue}
        setValue={setSearchValue}
        placeholder="Entrez le nom de l'instance"
      />

      <Button type="submit">Rechercher</Button>
    </form>
  );
}
